import SlideBox from './views/my-slide-box.vue';

export default {
  path: 'my-slide-box/:id',
  name: 'my-slide-box',
  component: SlideBox,
};
